import { useEffect, useRef } from 'react';
import { FixRotationScene } from '@modules/fixRotation/FixRotationScene.ts';
import { FixRotationUI } from '@modules/fixRotation/FixRotationUI.tsx';
import useThreeStore from '@modules/three/hooks/useThreeStore.ts';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner.tsx';

interface FixRotationProps {
  upperJawFile: File;
  lowerJawFile: File;
}

export function FixRotation({ upperJawFile, lowerJawFile }: FixRotationProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { isLoading } = useThreeStore();
  useEffect(() => {
    if (!containerRef.current) return;
    const scene = new FixRotationScene(containerRef.current);
    scene.init(upperJawFile, lowerJawFile);
    return () => {
      scene.dispose();
    };
  }, [containerRef, upperJawFile, lowerJawFile]);

  return (
    <div className="relative flex-1 min-h-0 h-full w-full">
      <div ref={containerRef} className="absolute inset-0" />
      {isLoading ? (
        <div className="absolute z-10 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex w-82 flex-col items-center rounded-2xl p-4 text-white">
          <LoadingSpinner className={''} />
        </div>
      ) : (
        <FixRotationUI />
      )}
    </div>
  );
}
